module.exports = __webpack_public_path__ + "static/media/risk-test-paper.b8471c23.pdf";